const ItemsCountDisplay = ({ currentPage, totalPages, totalUsers, pageSize = 8 }) => {
  // Calculate number of items currently shown
  const itemsShown =
    currentPage < totalPages ? currentPage * pageSize : totalUsers;

  return (
    <div className="numofItems">
      <p className="spancular">
        showing {itemsShown} of {totalUsers} users
      </p>
    </div>
  );
};

export default ItemsCountDisplay;
